import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import {BrowserRouter} from 'react-router';
import {ToastContainer} from 'react-toastify';

import GlobalProviders from '@/providers/globalProviders';

import ErrorBoundary from '@/components/ErrorBoundary';
import AppRouter from '@/components/router/AppRouter';

import './styles/style.scss';

// Other available, pre-compiled, css files
// import '../apps/exchange/assets/css/tailwind/toast.css';
// import '../apps/exchange/assets/css/plugins/plugins.css';
// import '../apps/exchange/assets/css/custom/job_landing.css';

function initializeApp() {
  // Create the host element for the React root
  const root = document.getElementById('root');
  if (!root) throw new Error('Root element not found');
  const reactRoot = createRoot(root);

  const app = (
    <ErrorBoundary>
      <GlobalProviders>
        <ErrorBoundary>
          <BrowserRouter basename="/">
            <AppRouter />
          </BrowserRouter>
        </ErrorBoundary>
        <ToastContainer limit={5} icon={false} closeOnClick={false} closeButton={false} />
      </GlobalProviders>
    </ErrorBoundary>
  );

  // Only use StrictMode in development to avoid double-mounting effects
  // This helps with performance in development while maintaining safety checks
  if (import.meta.env.DEV) {
    reactRoot.render(<StrictMode>{app}</StrictMode>);
  } else {
    reactRoot.render(app);
  }
}

initializeApp();
